import * as ApolloClient from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';

export const createApolloClient = (endpoint: string): any => {
    return new ApolloClient.ApolloClient({
        link: new HttpLink({
            uri: endpoint,
        }),
        cache: new InMemoryCache(),
    });
};
